var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangebuttonicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6175 2.88267C16.8677 2.13286 15.652 2.13286 14.9022 2.88267L7.61982 10.165V12.8803H10.3351L17.6175 5.59796C18.3673 4.84815 18.3673 3.63247 17.6175 2.88267Z",
    fill: "#BA0060"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81982 6.16031C2.81982 5.09993 3.67944 4.24031 4.73982 4.24031H8.57982C9.11002 4.24031 9.53982 4.67012 9.53982 5.20031C9.53982 5.73051 9.11002 6.16031 8.57982 6.16031H4.73982V15.7603H14.3398V11.9203C14.3398 11.3901 14.7696 10.9603 15.2998 10.9603C15.83 10.9603 16.2598 11.3901 16.2598 11.9203V15.7603C16.2598 16.8207 15.4002 17.6803 14.3398 17.6803H4.73982C3.67944 17.6803 2.81982 16.8207 2.81982 15.7603V6.16031Z",
    fill: "#BA0060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangebuttonicon);
export default __webpack_public_path__ + "static/media/changebuttonicon.0126a587376ed4da2503f43b1ecd96ac.svg";
export { ForwardRef as ReactComponent };